import { Divider, Stack, Typography, Link } from "@mui/material";
import MuiButton from "@mui/material/Button";
import DoneIcon from "@mui/icons-material/Done";
import { useNavigate } from "react-router-dom";
import plans from "../../_mock/hosting";

const Button = (props) => (
  <MuiButton
    sx={{
      borderRadius: 0,
      border: "1px solid black",
      color: "black",
      marginBlock: 2,
      width: "100%"
    }}
    {...props}
  />
);

export default function Hosting() {
  const navigate = useNavigate();
  return (
    <div>
      <Typography variant="h3">Packages</Typography>
      <Stack
        direction="row"
        spacing={0}
        sx={{ border: "1px solid #ccc" }}
        divider={<Divider orientation="vertical" flexItem />}
      >
        {plans.map((e, i) => (
          <div key={i} style={{ width: "100%", padding: "24px 12px" }}>
            <div style={{ height: 96 }}>
              <small>Prices as low as</small>
              <Stack direction="row" alignItems="end">
                <Typography variant="h3">&#8377;{e.price}</Typography>
                <span style={{ marginBottom: 8 }}>/mo</span>
              </Stack>
              {i === 1 && (
                <Typography
                  variant="body1"
                  style={{ backgroundColor: "#ffff084a", width: "fit-content" }}
                >
                  Popular
                </Typography>
              )}
            </div>
            <Button onClick={() => navigate("/dashboard/checkout")}>
              Select
            </Button>
            {e.features.map((feature) => (
              <Stack direction="row" key={feature}>
                <DoneIcon fontSize="small" sx={{ color: "#315a31" }} />{" "}
                <small>{feature}</small>
              </Stack>
            ))}
          </div>
        ))}
      </Stack>
    </div>
  );
}
